import React from 'react';


export default function MarkAsUnreadIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.8539 21.3885V19.0925C19.8539 17.8746 19.3701 16.7066 18.509 15.8454C17.6478 14.9843 16.4798 14.5005 15.262 14.5005H6.07801C4.86014 14.5005 3.69215 14.9843 2.83099 15.8454C1.96983 16.7066 1.48603 17.8746 1.48603 19.0925V21.3885" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.67 9.90856C13.2061 9.90856 15.262 7.85266 15.262 5.31659C15.262 2.78051 13.2061 0.724609 10.67 0.724609C8.13392 0.724609 6.07802 2.78051 6.07802 5.31659C6.07802 7.85266 8.13392 9.90856 10.67 9.90856Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
